import { render, staticRenderFns } from "./RipaGender.vue?vue&type=template&id=67989245"
import script from "./RipaGender.vue?vue&type=script&lang=js"
export * from "./RipaGender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports